import { render, staticRenderFns } from "./Conversations.bkp.vue?vue&type=template&id=1dbb3786&"
import script from "./Conversations.bkp.vue?vue&type=script&lang=js&"
export * from "./Conversations.bkp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports